import { useMutation } from "@tanstack/react-query";

import { RolePayloadModel } from "@/domain/model/roles";
import { QUERIES } from "@/enums/queries";

import updateRoleById from "./services/updateRoleById";
import { invalidateLoadRoles } from "./useLoadRoles";

const useUpdateRoleById = () => {
  const mutation = useMutation({
    mutationKey: [QUERIES.PROFILE.ROLES.UPDATE_BY_ID],
    mutationFn: async (data: RolePayloadModel) => await updateRoleById(data),
    onSuccess: async () => await invalidateLoadRoles(),
  });

  const updateRoleByIdReq = async (data: RolePayloadModel) =>
    mutation.mutateAsync(data);

  return {
    updateRoleById: updateRoleByIdReq,
    ...mutation,
  };
};

export default useUpdateRoleById;
